import $ from 'jquery';

function init() {
    let submit

    $('[data-ajax-form]').each(function() {
        $(this).on('submit', function(e) {
            e.preventDefault()
            if (!validateForm($(this))) return
            var formData = new FormData($(this)[0])
            if (submit) return
            window.sendAjax(formData, $(this));
            submit = true
        })
    })
    function validateForm(form) {
        form.find('.is-error').removeClass('is-error')
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        let isValid = true

        form.find('[data-rule-required]').each(function() {
            const type = $(this).attr('type')
            const textInputCheck = type === 'text' && $(this).val() === ''
            const telInputCheck = type === 'tel' && $(this).val().length < 16
            const emailInputCheck = type === 'email' && !emailRegex.test($(this).val())

            if(textInputCheck || telInputCheck || emailInputCheck) {
                $(this).addClass('is-error')
                $(this).parent().find('.tariffs__contacts-form-input-warm').css({opacity: 1})
                isValid = false
            } else {
                $(this).removeClass('is-error')
                $(this).parent().find('.tariffs__contacts-form-input-warm').css({opacity: 0})
            }
        })

        form.find('input[type=text]').on('input', function() {
            if($(this).val() !== '') {
                $(this).removeClass('is-error')
                $(this).parent().find('.tariffs__contacts-form-input-warm').css({opacity: 0})
            } else {
                $(this).addClass('is-error')
                $(this).parent().find('.tariffs__contacts-form-input-warm').css({opacity: 1})
            }
        })

        form.find('input[type=tel]').on('input', function() {
            if(!($(this).val().length < 16)) {
                $(this).removeClass('is-error')
                $(this).parent().find('.tariffs__contacts-form-input-warm').css({opacity: 0})
            } else {
                $(this).addClass('is-error')
                $(this).parent().find('.tariffs__contacts-form-input-warm').css({opacity: 1})
            }
        })

        form.find('input[type=email]').on('input', function() {
            if(emailRegex.test($(this).val())) {
                $(this).removeClass('is-error')
                $(this).parent().find('.tariffs__contacts-form-input-warm').css({opacity: 0})
                isValid = false
            }else {
                $(this).addClass('is-error')
                $(this).parent().find('.tariffs__contacts-form-input-warm').css({opacity: 1})
            }
        })

        return isValid
    }

    window.sendAjax = function (data, container) {
        $.ajax({
            type: 'POST',
            url: '/smm/ajax/',
            data: data,
            dataType: 'json',
            cache: false,
            contentType: false,
            processData: false,
            success: function (data) {
                submit = false
                $('[data-ajax-form]', 'input').each(function(input) {
                    input.value('')
                })
                container.closest('.request__col').find('.request__descr').hide();
                container.html(
                    '<div class="request__message text-12">Ваше сообщение успешно отправлено. Наш менеджер свяжется с Вами в ближайшее время.</div>',
                );
            },
            error: function (data) {
                submit = false
                $('[data-ajax-form]', 'input').each(function(input) {
                    input.value('')
                })
                container.closest('.request__col').find('.request__descr').hide();
                container.html(
                    '<div class="request__message text-12">При отправке формы произошла ошибка <br> Cтраница будет перезагружена...</div>',
                );
                setTimeout(()=> window.location.reload(), 3000)
            },
        });
    };

}

export default { init };
